import { type ValueOf } from '@models/helpers/custom'

export const LanguageList = {
  RU: 'ru',
  EN: 'en',
  DE: 'de',
  PTBR: 'pt-br',
  HI: 'hi',
  UK: 'uk',
  AZ: 'az',
  ES: 'es',
  UZ: 'uz',
  KK: 'kk',
  BN: 'bn'
} as const

export type LanguageType = ValueOf<typeof LanguageList>

export type LanguageInfoType = {
  key: LanguageType;
  title: string;
  shortName: string;
}
export type LanguageMapType = Record<LanguageType, LanguageInfoType>
export type DictionaryType = Record<LanguageType, Record<string, string>>
